/* eslint-disable */
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { DateTimeService } from 'src/app/services/date-time/date-time.service';
import { LoggerService } from 'src/app/services/logger.service';
import { PersonsService } from 'src/app/services/persons.service';
import { PosterService } from 'src/app/services/poster.service';
import { PrefsService } from 'src/app/services/prefs.service';
import { environment } from 'src/environments/environment';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.page.html',
  styleUrls: ['./feedback.page.scss']
})
export class FeedbackPage implements OnInit {
  feedback: any;
  email: any;
  name: any;
  password: any;
  studyId: any;
  feedbackSubmitError = false;
  formInvalid = false;
  requestFailed = false;
  invalidEmail = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public logger: LoggerService,
    private dateTime: DateTimeService,
    public http: HttpClient,
    public persons: PersonsService,
    private prefs: PrefsService,
    private poster: PosterService
  ) {}

  resetValidation() {
    this.feedbackSubmitError = false;
    this.invalidEmail = false;
    this.requestFailed = false;
    this.formInvalid = false;
  }

  submit() {
    const nowSeconds = this.dateTime.getNowSeconds();
    const URL = 'https://rsginchelp.zendesk.com/api/v2/requests';
    //let re = /^\S+@\S+\.\S+$/;
    // https://emailregex.com/ (matches survey validator for email)
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.resetValidation();

    if (!this.email || !this.name || !this.feedback) {
      this.feedbackSubmitError = true;
      this.formInvalid = true;
      return;
    }

    if (!re.test(this.email)) {
      this.feedbackSubmitError = true;
      this.invalidEmail = true;
      return;
    }

    const data = {
      request: {
        subject: this.feedback,
        tags: [environment.browserAppConfig.appId],
        via_id: 48,
        comment: {
          body: this.feedback,
          uploads: []
        },
        requester: {
          name: this.name,
          email: this.email,
          locale_id: 1
        },
        ticket_form_id: '360001520854',
        fields: {
          360024407814: this.studyId,
          360025788573: this.password
        }
      }
    };

    this.http.post(URL, data).subscribe(
      (res) => {
        this.logger.log('Posting ZenDesk', MSRemoteLoggerCategory.ROSTER_FEEDBACK_PAGE);
        const nowSeconds = this.dateTime.getNowSeconds();
        // send to zendesk, but also send to server
        this.poster.addThenSend('/feedback', { feedback: this.feedback, created: nowSeconds });
        this.feedback = '';
        this.dismiss();
      },
      (err) => {
        //not setting these and calling this.dismiss()- we're proxying through the server to zendesk (triggered by including dataForZenDesk below)
        //this.feedbackSubmitError = true;
        //this.requestFailed = true;

        this.logger.error('Error posting to zendesk', MSRemoteLoggerCategory.ROSTER_FEEDBACK_PAGE, err.status, err.data);
        this.poster.addThenSend('/feedback', { feedback: this.feedback, created: nowSeconds, dataForZenDesk: data });
        this.dismiss();
      }
    );
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  init() {
    // console.log('ionViewDidLoad FeedbackZendeskPage');
    this.prefs.getPromises('authCode', 'studyId').then((results) => {
      this.password = results[0];
      this.studyId = results[1];
    });

    this.persons.getDeviceOwner().then((person) => {
      this.name = person.name;
      this.email = person.hasOwnProperty('email') ? person.email : null;
    });
  }

  ionViewWillEnter() {
    this.init();
  }

  ngOnInit() {}
}
